// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-panel {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #ffffff;
  padding: 16px;
  width: 100%;
}

.dp-panel--sticky {
  position: sticky;
  top: 16px;
}

.dp-panel--scrollable {
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  overflow-x: hidden;
}

.dp-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.dp-title {
  margin-top: 0;
  margin-bottom: 0;
}

.dp-empty-text {
  margin-bottom: 0;
  color: #6b7280;
}

.dp-field {
  margin-bottom: 12px;
}

.dp-label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #111827;
}

.dp-input,
.dp-select,
.dp-textarea {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  box-sizing: border-box;
  background: #ffffff;
}

.dp-textarea {
  resize: vertical;
}

.dp-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #111827;
}

.dp-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.dp-section-title {
  margin-top: 0;
  margin-bottom: 12px;
}

.dp-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.dp-info-box {
  padding: 10px 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 13px;
}

.dp-preview-box {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  background: #f8fafc;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
}

.dp-preview-image {
  max-width: 100%;
  max-height: 160px;
  object-fit: contain;
  display: block;
}

.dp-button-primary {
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: #2563eb;
  color: #ffffff;
  cursor: pointer;
}

.dp-button-primary:hover {
  background: #1d4ed8;
}

.dp-collapse-toggle {
  min-width: 32px;
  height: 32px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #111827;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}

.dp-collapse-toggle:hover {
  background: #eef2ff;
  border-color: #93c5fd;
}

.dp-collapse-toggle--collapsed {
  width: 64px;
  min-width: 64px;
  height: 120px;
  padding: 8px 6px;
  font-size: 13px;
  font-weight: 700;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  border-radius: 10px;
  background: #ffffff;
}

.dp-collapsed-wrap {
  width: 64px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

/* shape picker */
.dp-shape-picker {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

/* دکمه‌های انتخاب شیپ */
.dp-shape-option {
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 10px;
  background: #f8fafc; /* قبلا سفید بود */
  color: #334155; /* متن تیره */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* آیکن داخل دکمه */
.dp-shape-option div:first-child {
  color: #475569; /* آیکن تیره */
}

/* هاور */
.dp-shape-option:hover {
  background: #e2e8f0;
}

/* حالت انتخاب شده */
.dp-shape-option--active {
  border-color: #2563eb;
  background: #dbeafe;
}

/* آیکن حالت انتخاب شده */
.dp-shape-option--active div:first-child {
  color: #2563eb;
}


.dp-shape-option-label {
  font-size: 12px;
  color: #334155;
  line-height: 1;
}

.dp-color-row {
  display: grid;
  grid-template-columns: 1fr 52px;
  gap: 8px;
  align-items: center;
}

.dp-color-input {
  width: 52px;
  height: 40px;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  box-sizing: border-box;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/designer/properties/DesignerPropertiesPanel.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB,EAAE,kBAAkB;EACvC,cAAc,EAAE,aAAa;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,cAAc,EAAE,cAAc;AAChC;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":[".dp-panel {\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 16px;\n  width: 100%;\n}\n\n.dp-panel--sticky {\n  position: sticky;\n  top: 16px;\n}\n\n.dp-panel--scrollable {\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.dp-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.dp-title {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.dp-empty-text {\n  margin-bottom: 0;\n  color: #6b7280;\n}\n\n.dp-field {\n  margin-bottom: 12px;\n}\n\n.dp-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 14px;\n  color: #111827;\n}\n\n.dp-input,\n.dp-select,\n.dp-textarea {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  box-sizing: border-box;\n  background: #ffffff;\n}\n\n.dp-textarea {\n  resize: vertical;\n}\n\n.dp-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #111827;\n}\n\n.dp-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.dp-section-title {\n  margin-top: 0;\n  margin-bottom: 12px;\n}\n\n.dp-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.dp-info-box {\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  color: #475569;\n  font-size: 13px;\n}\n\n.dp-preview-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 10px;\n  background: #f8fafc;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 120px;\n}\n\n.dp-preview-image {\n  max-width: 100%;\n  max-height: 160px;\n  object-fit: contain;\n  display: block;\n}\n\n.dp-button-primary {\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 8px;\n  background: #2563eb;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.dp-button-primary:hover {\n  background: #1d4ed8;\n}\n\n.dp-collapse-toggle {\n  min-width: 32px;\n  height: 32px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #111827;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.dp-collapse-toggle:hover {\n  background: #eef2ff;\n  border-color: #93c5fd;\n}\n\n.dp-collapse-toggle--collapsed {\n  width: 64px;\n  min-width: 64px;\n  height: 120px;\n  padding: 8px 6px;\n  font-size: 13px;\n  font-weight: 700;\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  border-radius: 10px;\n  background: #ffffff;\n}\n\n.dp-collapsed-wrap {\n  width: 64px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n}\n\n/* shape picker */\n.dp-shape-picker {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n/* دکمه‌های انتخاب شیپ */\n.dp-shape-option {\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  padding: 10px;\n  background: #f8fafc; /* قبلا سفید بود */\n  color: #334155; /* متن تیره */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n/* آیکن داخل دکمه */\n.dp-shape-option div:first-child {\n  color: #475569; /* آیکن تیره */\n}\n\n/* هاور */\n.dp-shape-option:hover {\n  background: #e2e8f0;\n}\n\n/* حالت انتخاب شده */\n.dp-shape-option--active {\n  border-color: #2563eb;\n  background: #dbeafe;\n}\n\n/* آیکن حالت انتخاب شده */\n.dp-shape-option--active div:first-child {\n  color: #2563eb;\n}\n\n\n.dp-shape-option-label {\n  font-size: 12px;\n  color: #334155;\n  line-height: 1;\n}\n\n.dp-color-row {\n  display: grid;\n  grid-template-columns: 1fr 52px;\n  gap: 8px;\n  align-items: center;\n}\n\n.dp-color-input {\n  width: 52px;\n  height: 40px;\n  padding: 4px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  background: #ffffff;\n  box-sizing: border-box;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
